"use client";

import { useEffect, useState } from "react";
import { useCart } from "@/stores/cart-store";

/**
 * Total cart quantity, hydration-safe for the header/products cart badge.
 *
 * Returns 0 on the server AND the first client render (so the badge is absent
 * in both → no React #418 hydration mismatch), then the real persisted count
 * after mount. It uses a local `mounted` flag flipped in an effect — the same
 * pattern as AnnouncementBar / CookieConsent — rather than the store's
 * `_hasHydrated` flag, which is set from inside `onRehydrateStorage` and does
 * not reliably flip in the production build (that left the badge permanently
 * hidden). `items` is read live, so adding/removing updates the count normally.
 */
export function useHydratedCartCount(): number {
  const items = useCart((s) => s.items);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- deliberately reveal the persisted count only after the hydration-safe first client render.
    setMounted(true);
  }, []);
  return mounted ? items.reduce((sum, i) => sum + i.quantity, 0) : 0;
}
